import { Component, OnInit, Input, Inject } from '@angular/core';
import {
  UntypedFormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  AsyncValidatorFn,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PerfilesPop } from '@pages/fabrica-credito/interfaces/perfil';
import { PerfilService } from '@pages/perfil/services/perfil.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { SwalService } from '@shared/utils/swal.service';
import { VariablesComponent } from '@pages/variables/variables.component';
import { RangosComponent } from '@pages/rangos/rangos.component';
import { Rangos } from '@pages/fabrica-credito/interfaces/rangos';
import { RangosService } from '@pages/rangos/services/rangos.service';
import { ModulesFormComponent } from '@pages/modules-permission/modules-permission/modules-form/modules-form.component';
import { ProductosComponent } from '@pages/productos/productos.component';
import { ActividadesComponent } from '@pages/actividades/actividades.component';

@Component({
  selector: 'app-rangos-form',
  templateUrl: './rangos-form.component.html',
  styleUrls: ['./rangos-form.component.css'],
})
export class RangosFormComponent implements OnInit {
  @Input() modelRecived: Rangos;
  public loading: boolean;
  public breakpoint: number;
  clavePerfil: string;
  private readonly _width: string = '900px';
  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<RangosComponent>,
    private _swalService: SwalService,
    private _injectServices: InjectableService,
    private _rangosService: RangosService,
    public _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public model: Rangos
  ) {}

  ngOnInit(): void {
    this.setForm();
    this.clavePerfil = JSON.parse(sessionStorage.getItem('clavePerfil'));
  }

  form = this._fb.group({
    clavePerfil: [''],
    variable: [''],
    rango1: [''],
    rango2: [''],
    valorStr: [''],
    politica: [''],
    comentario: [''],
    siguiente: [''],
    score: [0],
    rango: [0],
    consecutivo: [0],
    user: [''],
  });

  formValue(value: string) {
    return this.form.get(value);
  }

  setForm(): void {
    this.modelRecived = this.model;
    if (this.modelRecived) {
      let model: Rangos = this.modelRecived;
      const setModel = {
        clavePerfil: model.clavePerfil,
        variable: model.variable,
        rango1: model.rango1,
        rango2: model.rango2,
        valorStr: model.valorStr,
        politica: model.politica,
        comentario: model.comentario,
        siguiente: model.siguiente,
        score: model.score,
        rango: model.rango,
      };
      this.form.patchValue(setModel);
    }
  }

  create(model: Rangos) {
    if (this.form.valid) {
      model.user = JSON.parse(sessionStorage.getItem('Usser'));
      model.valorStr = this.form?.controls.valorStr.value.toString();
      model.politica = this.form?.controls.politica.value.toString();
      this.loading = true;
      this._rangosService.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else
          this._swalService.error(
            'No Agregado, Puede ser que la clave ya exista, valide con una diferente por favor!'
          );
      });
    }
  }

  update(model: Rangos) {
    if (this.form.valid) {
      this.loading = true;
      this._rangosService.update(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }

  variableValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const variable = control.value;

      if (!variable) return;

      if (variable < 501 || variable > 600) return { variableValidation: true };

      return null;
    };
  }

  openProductos() {
    const dialogRef = this._dialog.open(ProductosComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  openActividades() {
    const dialogRef = this._dialog.open(ActividadesComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  singleDefinicion(): AsyncValidatorFn {
    return (
      control: AbstractControl
    ): Promise<ValidationErrors> | Observable<any> => {
      if (this.modelRecived) return of(true);
      else {
        return this._rangosService.read(this.clavePerfil).pipe(
          map((res) => {
            if (res.exito === 1) return { singleDefinicion: true };
            return null;
          })
        );
      }
    };
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 200 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 200 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }
}
